// ============================================================================
// TERMS MOBILE COMPONENT
// ============================================================================
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg';

function TermsMobile() {
  const [quickEmail, setQuickEmail] = useState('');
  const [quickPassword, setQuickPassword] = useState('');
  const [showQuickLogin, setShowQuickLogin] = useState(false);

  // Forgot Password States
  const [isForgotMode, setIsForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMessage, setForgotMessage] = useState('');

  const handleQuickLogin = async (e) => {
    e.preventDefault();
    try {
      localStorage.removeItem('instructorId');
      localStorage.removeItem('learnerId');
      localStorage.removeItem('userId');
      localStorage.removeItem('adminToken');

      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: quickEmail, password: quickPassword })
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('needsPasswordReset', data.needsPasswordReset ? 'true' : 'false');

        if (data.role === 'admin') {
          localStorage.setItem('userRole', 'admin');
          localStorage.setItem('adminToken', data.token || 'mock-admin-token-secure');
          window.location.assign('/admin');
        } else if (data.role === 'instructor') {
          localStorage.setItem('userRole', 'instructor');
          localStorage.setItem('instructorId', data.id || data.instructorId);
          localStorage.setItem('token', data.token || '');
          window.location.assign('/instructor-dash');
        } else {
          localStorage.setItem('userRole', 'learner');
          localStorage.setItem('userId', data.id || data.userId);
          localStorage.setItem('learnerId', data.id || data.userId);
          localStorage.setItem('userName', data.name || "Learner Driver");
          localStorage.setItem('token', data.token || '');
          window.location.assign(`/learner-dash/${data.instructor_id || 5}`);
        }
      } else {
        alert(data.error || "Login failed.");
      }
    } catch (err) {
      alert("Server error.");
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (res.ok) {
        setForgotMessage('Password reset link sent! Check your email.');
      } else {
        setForgotMessage(data.error || 'Could not send reset link.');
      }
    } catch (err) {
      setForgotMessage('Server error. Please try again.');
    }
  };

  return (
    <div style={{ padding: '0 0 50px 0', maxWidth: '100%', margin: '0 auto', color: '#ffffff', fontFamily: 'inherit', background: '#0f172a', minHeight: '100vh', boxSizing: 'border-box' }}>
      
      {/* --- MINIMALIST APP HEADER --- */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', background: '#090d16', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'sticky', top: 0, zIndex: 1000 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={schoolLogo} alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #3b82f6' }} />
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ color: '#fff', fontWeight: '800', fontSize: '1.1rem', letterSpacing: '-0.5px', textDecoration: 'none' }}>LessonLane</Link>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} title="Home" style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', padding: '6px 10px', borderRadius: '8px', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="#FFFFFF"/>
            </svg>
          </Link>
          <button 
            onClick={() => { setShowQuickLogin(!showQuickLogin); setIsForgotMode(false); setForgotMessage(''); }}
            title="Portal Login"
            style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C9.24 2 7 4.24 7 7C7 9.42 8.74 11.43 11 11.9V13.1C7.58 13.54 5 16.48 5 20H19C19 16.48 16.42 13.54 13 13.1V11.9C15.26 11.43 17 9.42 17 7C17 4.24 14.76 2 12 2Z" fill="#FFFFFF"/>
            </svg>
          </button>
        </div>
      </div>

      {/* --- QUICK LOGIN / FORGOT PASSWORD EXPANDABLE BOX --- */}
      {showQuickLogin && (
        <div style={{ padding: '16px 16px 0 16px', maxWidth: '450px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
          {!isForgotMode ? (
            <form onSubmit={handleQuickLogin} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Portal Sign In</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <input 
                type="email" 
                placeholder="Email address" 
                value={quickEmail} 
                onChange={e => setQuickEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <input 
                type="password" 
                placeholder="Password" 
                value={quickPassword} 
                onChange={e => setQuickPassword(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <div style={{ textAlign: 'right', marginBottom: '12px' }}>
                <button 
                  type="button"
                  onClick={() => { setIsForgotMode(true); setForgotMessage(''); }}
                  style={{ background: 'none', border: 'none', fontSize: '11.5px', color: '#60a5fa', textDecoration: 'none', cursor: 'pointer', padding: 0 }}
                >
                  Forgot password?
                </button>
              </div>
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
                Sign In
              </button>
            </form>
          ) : (
            <form onSubmit={handleForgotPasswordSubmit} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Reset Password</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <p style={{ fontSize: '11.5px', color: '#94a3b8', marginBottom: '12px', lineHeight: '1.4' }}>
                Enter your account email and we'll send you a recovery link.
              </p>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                value={forgotEmail} 
                onChange={e => setForgotEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              {forgotMessage && (
                <div style={{ fontSize: '11.5px', color: forgotMessage.includes('sent') ? '#10b981' : '#f87171', marginBottom: '10px' }}>
                  {forgotMessage}
                </div>
              )}
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', marginBottom: '8px' }}>
                Send Reset Link ➔
              </button>
              <div style={{ textAlign: 'center' }}>
                <button 
                  type="button" 
                  onClick={() => setIsForgotMode(false)}
                  style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11px', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Back to Sign In
                </button>
              </div>
            </form>
          )}
        </div>
      )}

      {/* --- TERMS CONTENT CONTAINER --- */}
      <div style={{ padding: '24px 16px', maxWidth: '600px', margin: '0 auto', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h1 style={{ fontSize: '1.6rem', fontWeight: '900', margin: '0 0 6px', color: '#ffffff' }}>Terms & Conditions</h1>
          <p style={{ color: '#94a3b8', fontSize: '0.84rem' }}>Please read these terms carefully before using LessonLane.</p>
        </div>

        <div style={{ background: '#162238', padding: '20px', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '0.85rem', lineHeight: '1.5', color: '#cbd5e1' }}>
          <section>
            <h3 style={{ color: '#fff', fontSize: '0.95rem', fontWeight: '800', marginBottom: '6px' }}>1. Acceptance of Terms</h3>
            <p style={{ margin: 0, color: '#94a3b8' }}>By accessing or using the LessonLane platform, you agree to be bound by these terms. If you do not agree, please refrain from using our services.</p>
          </section>

          <section>
            <h3 style={{ color: '#fff', fontSize: '0.95rem', fontWeight: '800', marginBottom: '6px' }}>2. Instructor Accounts & Responsibilities</h3>
            <p style={{ margin: 0, color: '#94a3b8' }}>Independent instructors using LessonLane are responsible for maintaining accurate schedules, managing student progression responsibly, and complying with all local driving instruction regulations.</p>
          </section>

          <section>
            <h3 style={{ color: '#fff', fontSize: '0.95rem', fontWeight: '800', marginBottom: '6px' }}>3. Data Privacy & Security</h3>
            <p style={{ margin: 0, color: '#94a3b8' }}>We take your privacy seriously. All user credentials, student logs, and mapping information are handled securely in accordance with our data protection guidelines.</p>
          </section>

          <section>
            <h3 style={{ color: '#fff', fontSize: '0.95rem', fontWeight: '800', marginBottom: '6px' }}>4. Modifications to Service</h3>
            <p style={{ margin: 0, color: '#94a3b8' }}>LessonLane reserves the right to modify or discontinue features of the platform at any time to improve performance and user experience.</p>
          </section>
        </div>
      </div>

      {/* --- MOBILE FOOTER --- */}
      <div style={{ textAlign: 'center', padding: '20px 16px', background: '#090d16', color: '#94a3b8', marginTop: '30px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <p style={{ fontSize: '11px', margin: 0 }}>
          &copy; 2026 LessonLane.co.uk. All rights reserved.
        </p>
      </div>

    </div>
  );
}

export default TermsMobile;